import React, { Suspense } from 'react';
import { Loading } from '@roc-digital/ui-web';

const AppContainer = ({ children }: { children: React.ReactNode }) => {
  return <Suspense fallback={<Loading />}>{children}</Suspense>;
};

export default AppContainer;
